<template>
    <router-link :to="{
        path: '/login',
        query: {
            ...$route.query,
            ...originQuery,
        }
    }">
        <i class="fa fa-angle-left nav-back-btn"></i>
        <slot></slot>
    </router-link>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'NavBackButton',
    computed: {
        ...mapState({
            originQuery: state => state.app.originQuery,
        }),
    },
}
</script>

<style scoped>
.nav-back-btn {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    /*height: max-content;*/
    width: 32px;
    height: 32px;
    line-height: 32px;
    margin: auto;
}
</style>
